import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'cbr_admin_token';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [checking, setChecking] = useState(true);
  const [isAuthed, setIsAuthed] = useState(false);

  const verify = useCallback(async (t) => {
    if (!t) {
      setIsAuthed(false);
      setChecking(false);
      return false;
    }
    try {
      await axios.get(`${API_URL}/api/admin/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      setIsAuthed(true);
      setChecking(false);
      return true;
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      setIsAuthed(false);
      setChecking(false);
      return false;
    }
  }, []);

  useEffect(() => {
    verify(token);
  }, [verify, token]);

  const login = async (password) => {
    const { data } = await axios.post(`${API_URL}/api/admin/login`, { password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setToken(data.token);
    setIsAuthed(true);
    return true;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setIsAuthed(false);
  };

  const authedAxios = useCallback(() => {
    return axios.create({
      baseURL: API_URL,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  }, [token]);

  return (
    <AdminAuthContext.Provider value={{ token, isAuthed, checking, login, logout, authedAxios }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used inside AdminAuthProvider');
  return ctx;
};
